<template>
  <v-dialog v-model="dialog" persistent width="1600">
    <template v-slot:activator="{ on }">
      <v-icon
        small
        v-on="on"
        class="mr-2"
        v-tooltip="$t('customer_templates.import')"
        >import_export</v-icon
      >
    </template>
    <v-card min-height="700">
      <v-card-title class="headline lighten-2" primary-title>{{
        $t("customer_templates.export_templates")
      }}</v-card-title>
      <v-card-text style="height:640px;">
        <div class="container">
          <div class="row">
            <div class="col">
              <v-flex>
                <v-text-field
                  type="number"
                  :label="$t('customer_templates.logo_width')"
                  v-model="logoWidth"
                ></v-text-field>
              </v-flex>
              <div class="upload-btn-wrapper">
                <button class="btn">{{ $t("customer_templates.logo") }}</button>
                <input
                  id="logoFile"
                  ref="logoFile"
                  type="file"
                  name="myfile"
                  accept=".png, .jpg, .jpeg"
                  @input="checkFile"
                />
              </div>
              {{ chosenFileName }}
            </div>
            <div class="col">
              <div v-if="loadEditor">
                <text-editor
                  :startingCode="startingCode"
                  @codeChanged="recordCodeChange"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="image_result_wrapper">
                <img
                  :class="{ hideImage: !showImage }"
                  id="image"
                  :src="imageSrc"
                  width="60%"
                  height="auto"
                />
              </div>
            </div>
            <div class="col">
              <div class="html_result_wrapper" v-if="loadEditor">
                <div v-html="htmlCode"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-flex xs24 sm12 md12>
                <v-select
                  v-model="language"
                  :items="availableLanguages"
                  :label="$t('company_templates.language')"
                ></v-select>
              </v-flex>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="dialog = false">{{
          $t("customer_templates.cancel")
        }}</v-btn>
        <v-btn color="primary" flat @click="saveTemplate">{{
          $t("customer_templates.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TextEditor from "@/components/TextEditor.vue";
import Template from "@/models/Template.js";
export default {
  name: "customer-templates",
  props: ["customer"],
  data() {
    return {
      language: "en",
      availableLanguages: [
        {
          text: this.$t("company_templates.english"),
          value: "en"
        },
        {
          text: this.$t("company_templates.lithuanian"),
          value: "lt"
        }
      ],
      dialog: false,
      alreadyLoaded: false,
      showImage: false,
      loadEditor: false,
      logoWidth: 190,
      startingCode: `
      <html>
        <body>
          <span style="color:black;font-size:16px">
            <b>${this.$t("customer_templates.first_line")}</b><br>
            ${this.$t("customer_templates.second_line")}<br>
            ${this.$t("customer_templates.third_line")}<br>
          </span>
        </body>
      </html`,
      htmlCode: this.startingCode,
      chosenFileName: null,
      imageSrc: null
    };
  },
  mounted() {
    window.addEventListener("keydown", event => {
      if (event.keyCode === 27 && this.dialog) {
        this.dialog = false;
      }
    });
  },
  watch: {
    dialog(val) {
      if (val) {
        //load existing if there is such
        if (
          (this.customer.truck_list_template != null ||
            this.customer.pallet_list_template ||
            null) &&
          !this.alreadyLoaded
        ) {
          const templateId = this.customer.truck_list_template
            ? this.customer.truck_list_template
            : this.customer.pallet_list_template;
          this.loadCustomerTemplate(templateId);
          this.alreadyLoaded = true;
        }
        setTimeout(() => {
          this.loadEditor = true;
        }, 500);
      }
    }
  },
  methods: {
    async saveTemplate() {
      const imageFile = this.$refs.logoFile.files[0];
      let saving = true;
      //ask if still wants to go without logo
      if (imageFile == null) {
        saving = confirm(this.$t("customer_templates.logo_not_set"));
      }
      //if not quit
      if (!saving) {
        return null;
      }
      //set formData
      const logoWidth = this.getLogoWidth();
      let formData = new FormData();
      formData.append("logo_width", logoWidth);
      formData.append("type", "pallet");
      formData.append("language", this.language);
      formData.append("customer_id", this.customer.id);
      if (this.htmlCode != null) formData.append("header", this.htmlCode);
      if (imageFile != null) formData.append("image", imageFile);
      //save template
      try {
        await Template.createTemplate(formData);
        formData.append("type", "truck");
        await Template.createTemplate(formData);
        alert(
          this.$t("customer_templates.template_set") + " " + this.customer.name
        );
        this.dialog = false;
      } catch {
        alert(this.$t("customer_templates.template_upload_error"));
      }
    },

    /**
     * retrieves users template
     * and tries to load logo and header
     * @param templateId
     */
    async loadCustomerTemplate(templateId) {
      const template = await Template.loadTemplate(templateId);
      this.loadCustomerHeader(template);
      this.loadCustomerLogo(template);
    },

    /**
     * if user already has template logo loads it
     * @param template
     */
    loadCustomerLogo(template) {
      if (template.image_path) {
        this.imageSrc = template.image_path;
        this.showImage = true;
      }
    },

    /**
     * if user already has template header
     * loads it
     * @param template
     */
    loadCustomerHeader(template) {
      if (template.header_content != null) {
        this.startingCode = template.header_content;
        this.htmlCode = template.header_content;
      }
    },

    /**
     * gets current code value from component
     * @param code
     */
    recordCodeChange(code) {
      this.htmlCode = code;
    },

    /**
     * checks file and unbinds if value not correct
     */
    checkFile() {
      const allowedFileTypes = ["image/jpg", "image/jpeg", "image/png"];
      const file = this.$refs.logoFile.files[0];
      this.displaysLoadedImage(file);
      if (!allowedFileTypes.includes(file.type)) {
        this.$refs.logoFile.files[0] = null;
        this.chosenFileName = null;
        this.showImage = false;
        alert(this.$t("customer_templates.not_allowed_file_type"));
        return 0;
      }
      this.chosenFileName = file.name;
    },

    /**
     * gets image to display data
     * and shows it on dom
     * @param file
     */
    displaysLoadedImage(file) {
      let reader = new FileReader();
      reader.onload = event => {
        this.imageSrc = event.target.result;
      };
      reader.readAsDataURL(file);
      this.showImage = true;
    },

    /**
     * returns logo width
     * if too small set, just return default 100
     */
    getLogoWidth() {
      if (this.logoWidth == "" || this.logoWidth < 10) {
        alert(this.$t("customer_templates.logo_width_too_small") + " 10");
        return 10;
      }
      return this.logoWidth;
    }
  },
  components: {
    TextEditor
  }
};
</script>

<style scoped>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn {
  border: 2px solid rgb(25, 118, 210);
  color: rgb(25, 118, 210);
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.hideImage {
  display: none;
}
.html_result_wrapper {
  margin-top: 10px;
  background-color: rgb(241, 241, 248);
  width: 500px;
  height: 200px;
}
.image_result_wrapper {
  margin-top: 10px;
}
</style>
